import {
  Button, Stack, TableCell, TableRow, styled, tableCellClasses,
  Dialog, DialogTitle, DialogContent, DialogContentText,
  DialogActions, ListItemText, Paper, ListItemButton,
} from "@mui/material";
import React, { Dispatch, FC, useState } from "react";
import { btnStyle } from "../user/Tabs/utilisateur/UtilisateurRow";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import { AxiosInstance } from "axios";
import { DataRef } from "../../../../types/DataRef";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import OptionalWidthModal from "../../../../commons/optional-width-modal/OptionalWidthModal";
import SecteurActiviteForms from "../../../forms/secteurActivite/SecteurActiviteForms";
import { AlertType } from "../../../../types/AlertType";
import { LoadingButton } from "@mui/lab";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import DeleteIcon from "@mui/icons-material/Delete";

interface paysRowsAtribute {
  row: DataRef;
  isDesktopOrLaptop: boolean;
  http: AxiosInstance;
  reloadList: () => void;
  onClose: () => void;
  setOpenSnack: Dispatch<React.SetStateAction<boolean>>;
  setAlerteMessage: Dispatch<React.SetStateAction<string>>;
  setAlertType: Dispatch<React.SetStateAction<AlertType>>;
}

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.body}`]: {
    fontSize: 12,
    textAlign: "center",
    color: "#fff",
  },
}));

const SecteurActiviteRow: FC<paysRowsAtribute> = ({
  row,
  http,
  isDesktopOrLaptop,
  reloadList,
  setOpenSnack,
  setAlerteMessage,
  setAlertType,
  onClose,
}) => {
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [openModalDelete, setOpenModalDelete] = useState<boolean>(false);
  const [isCliqDetele, setIsCliqDelete] = useState<boolean>(false);
  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleDelete = (): void => {
    setIsCliqDelete(true);
    const data = {
      id: row?.id
    }

    http.post(`secteuract/delete`, data).finally(() => {
      setOpenModalDelete(false);
      setIsCliqDelete(false);
      reloadList();
    });
  };

  return (
    <>
      {isDesktopOrLaptop ? (
        <TableRow>
          <StyledTableCell>{row?.libelle}</StyledTableCell>
          <StyledTableCell>
            <Stack
              direction="row"
              spacing={1}
              display="flex"
              justifyContent="center"
            >
              <Button
                size="small"
                variant="outlined"
                sx={btnStyle({
                  bgColor: "#070d23",
                  hoverColor: "Gray",
                  color: "#fff",
                })}
                startIcon={<BorderColorIcon />}
                onClick={() => setOpenModal(true)}
              >
                Modifier
              </Button>
              <Button
                size="small"
                variant="outlined"
                sx={btnStyle({
                  bgColor: "#FF0000",
                  hoverColor: "#FE3737",
                })}
                startIcon={<DeleteForeverIcon />}
                onClick={() => { setOpenModalDelete(true) }}
              >
                Supprimer
              </Button>
            </Stack>
          </StyledTableCell>
        </TableRow>
      ) : (
        <Paper
          sx={{
            bgcolor: '#fff',
            color: '#080d24',
            mb: 1
          }}
          variant="outlined"
        >
          <ListItemButton
            alignItems="flex-start"
            sx={{
              justifyContent: "space-between",
            }}
          >
            <ListItemText
              primary={row.libelle}
              primaryTypographyProps={{
                fontSize: 12,
                fontWeight: "small",
                lineHeight: "15px",
                mt: 1,
                mb: "1px",
              }}
              sx={{ my: 0 }}
            />

            <Stack direction='row'>
              <Button
                size="small"
                variant="text"
                color="inherit"
                onClick={() => setOpenModal(true)}
              >
                <BorderColorIcon fontSize="small" />
              </Button>
              <Button
                size="small"
                variant="text"
                color="error"
                onClick={() => setOpenModalDelete(true)}
              >
                <DeleteIcon fontSize="small" />
              </Button>
            </ Stack>
          </ListItemButton>
        </Paper>
      )}

      <OptionalWidthModal
        title="Modifier un Secteur D'activite"
        // breackPoint="lg"
        onClose={handleCloseModal}
        open={openModal}
      >
        <SecteurActiviteForms
          row={row}
          onClose={handleCloseModal}
          reloadList={reloadList}
          setAlertType={setAlertType}
          setAlerteMessage={setAlerteMessage}
          setOpenSnack={setOpenSnack}
          http={http}
        />
      </OptionalWidthModal>

      <Dialog
        open={openModalDelete}
        // TransitionComponent={Transition}
        keepMounted
        onClose={() => { setOpenModalDelete(false) }}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>{"Confirmation"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            Vous êtes sur le point de supprimer cet secteur d'activité, êtes-vous sûr de
            vouloir poursuivre cette action ?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <LoadingButton
            onClick={() => handleDelete()}
            endIcon={<DeleteIcon />}
            loading={isCliqDetele}
            loadingPosition="end"
            sx={{ textTransform: "none" }}
            variant="contained"
            color="warning"
          >
            Oui
          </LoadingButton>
          <Button
            onClick={() => { setOpenModalDelete(false) }}
            variant="contained"
            color="inherit"
            sx={{ textTransform: "none" }}
            startIcon={<ExitToAppIcon />}
          >
            Non
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default SecteurActiviteRow;
